




    import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
    import dataProxyService from "@/services/data-proxy.service";
    import { GrupaVozila } from '@/services/BackendProxies';

@Component({})
export default class NaciniNabavkeVozilaEditor extends Vue {
    naciniNabavke = [];
    @Prop() value !: string;
    @Prop({default: false}) invalid!: boolean;

    model = '';

    async created() {
        const naciniNabavke = await dataProxyService.vratiNacineNabavkeVozila();
        naciniNabavke.unshift(GrupaVozila.fromJS({id: '', naziv: '...'}));
        this.naciniNabavke = naciniNabavke.map(nnv => ({id: nnv.id, text: nnv.naziv}));
        this.model = this.value;
    }

    @Watch("value") onValueChange(val) {
        this.model = val;
    }

    @Watch("model") onModelChange(val) {
        this.input(val);
    }

    @Emit() input(val) {

    }

}
